/*
 * @Author: kaifei.shang(尚锴飞) kaifei.shang@advantech.com.cn
 * @Date: 2023-03-09 14:41:31
 * @LastEditors: kaifei.shang(尚锴飞) kaifei.shang@advantech.com.cn
 * @LastEditTime: 2023-09-25 11:03:30
 * @FilePath: /eSpareParts-Portal/src/store/modules/auth.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ROLE_TYPE } from './../../config/global';
import { defineStore } from 'pinia'
import { store } from '../index'

export const useAuthStore = defineStore({
  id: 'auth',
  state: () => ({
    userInfo:{

    },
    orgInfo: {
      id: 1
    },
    tenantId:'',
    switchOrgDialogShow: false
  }),
  getters: {
    getTenantId(): any {
      return this.tenantId
    },    
    getOrgInfo(): any {
      return this.orgInfo
    },
    getUserInfo(): any {
      return this.userInfo
    },
    getSwitchOrg(): any {
      return this.switchOrgDialogShow
    },
    isOrgAdmin(): any {
      return this.getUserInfo.role_type === ROLE_TYPE.ADMIN
    },
    isSuperAdmin(): any {
      return this.getUserInfo.role_type === ROLE_TYPE.SUPERADMIN
    },
    isPartsSuperAdmin(): any {
      return this.getUserInfo.role_type === ROLE_TYPE.PARTSSUPERADMIN
    },
  },
  actions: {
    setTenantId(payload: any) {
      this.tenantId = payload
    },    
    setOrgInfo(payload: any) {
      console.log("setOrgInfo:", payload)
      this.orgInfo = payload
    },
    setUserInfo(payload: any) {
      console.log("setUserInfo:", payload)
      this.userInfo = payload
    },
    setSwitchOrg(payload: any) {
      this.switchOrgDialogShow = payload
    },
    getUsersAuthByModule(moduleName: any): any {
      console.log("getUsersAuthByModule:", moduleName)
      let auths = []
      if (this.getUserInfo.auth) {
        auths = JSON.parse(this.getUserInfo.auth)
      }
      for (const auth of auths as any) {
        if (auth.id === moduleName) {
          return auth
        }
        for (const child of auth.children as any) {
          if (child.id === moduleName) {
            return child
          }
        }
      }
      return {}
    }
  }
})

export const useAuthStoreWithOut = () => {
  return useAuthStore(store)
}
